/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var ArrowAUpRightIcon24Regular = forwardRef('ArrowAUpRightIcon24Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 24 }, props),
        React.createElement("path", { d: "M7.5 3.125a.875.875 0 1 0 0 1.75h10.388L3.88 18.881A.875.875 0 1 0 5.12 20.12L19.125 6.112V16.5a.875.875 0 0 0 1.75 0V6A2.875 2.875 0 0 0 18 3.125H7.5Z" })));
});
